import React, { useEffect, useState } from 'react'
import patologias from './patologias'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { PostAnexoDoc } from '../../../actions'
import { useDispatch } from 'react-redux'



const Anexo = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const {userId} = useParams()
  const token = localStorage.getItem('token')

  const [ input, setInput ] = useState({
    historiaClinica: '',
    patologias: 'Anorexia',
  })
  const [tratamientos, setTratamiento] = useState("")
  const [procedimientos, setProcedimientos] = useState("")
  const [beneficio, setBeneficios] = useState("")
  const [consecuencia, setConsecuencias] = useState("")
  const [riesgo, setRiesgo] = useState("")

  useEffect(() => {
    const t = patologias.find(f=>f.nombre===input.patologias)?.tratamiento  
    const p = patologias.find(f=>f.nombre===input.patologias)?.procedimiento  
    const b = patologias.find(f=>f.nombre===input.patologias)?.beneficios  
    const c = patologias.find(f=>f.nombre===input.patologias)?.consecuencias  
    const r = patologias.find(f=>f.nombre===input.patologias)?.riesgos  
    setTratamiento(t)
    setProcedimientos(p)
    setBeneficios(b)
    setConsecuencias(c)
    setRiesgo(r)
  }, [input,patologias]);

  useEffect(() => {
    setInput({
      ...input,
      tratamiento:tratamientos,
      procedimientos:procedimientos,
      beneficios:beneficio,
      consecuencias:consecuencia,
      riesgos:riesgo
    })
  }, [tratamientos]);

  const handleChange = (e) => {
    setTratamiento("")
    setProcedimientos("")
    setBeneficios("")
    setConsecuencias("")
    setRiesgo("")
    setInput({
      ...input,
      [e.target.name]: e.target.value
    })
  }

  const handleChangeDate= (e)=>{
    setInput({
      ...input,
      [e.target.name]: e.target.value
    })
  }


 

  const handleSubmit = (e) =>{
    e.preventDefault()
    dispatch(PostAnexoDoc(input,userId,token))
    navigate('/adminpanel/' + userId);
  }


  return (
    <div className='flex flex-col items-center justify-center p-8 gap-10'>
      <Link to={'/adminpanel/' + userId}>
      <button className='w-20 rounded p-2 bg-background_home text-white'>VOLVER</button>
      </Link>
        <form className='border p-10 flex flex-col gap-6 rounded shadow-xl w-full sm:w-4/6'>
            <div className='flex flex-col items-center justify-center gap-4'>
              <h1 className='font-bold'>ANEXO III</h1>
              <h1 className='font-bold'>CONSENTIMIENTO INFORMADO BILATERAL</h1>
            </div>
           <div className='flex flex-col'>
           <span className='text-slate-300'>Historia Clinica Nro: </span>
           <input type="text" value={input.value} name='historiaClinica' className='border rounded p-2 text-xs' onChange={handleChange}/>
           </div>

           <div className='flex flex-col'> 
            <span className='text-slate-300'>PRIMERO: </span>
             <select name="patologias" className='border rounded p-2 text-xs' onChange={handleChange}>
               {
                  patologias.map((option, ind) => {
                     return (       
                      <option key={ind} value={input.value} className='bg-background_home text-white'> {option.nombre} </option>                    
                      )
                  })
               }
              </select>
            </div>

            <div className='flex flex-col'>
                <span className=' text-slate-300'>Tratamiento: </span>
                {tratamientos?
                  <p name='beneficiosTratamiento'  className='border rounded p-2 text-xs'>{tratamientos}</p>:
                  <textarea type="text" placeholder='Los tratamientos propuesto consisten en ' className='border rounded p-2 text-xs' onChange={handleChange} />
                }
            </div>

            <div className='flex flex-col'>
                <span className=' text-slate-300'>Procedimientos del tratamiento: </span>
                {procedimientos?
                  <p name='beneficiosTratamiento'  className='border rounded p-2 text-xs'>{procedimientos}</p>:
                  <textarea type="text" placeholder='Los procedimientos del tratamiento propuesto consisten en '  className='border rounded p-2 text-xs' onChange={handleChange} />
                }
            </div>
               
            <div className='flex flex-col'>
                <span className=' text-slate-300'>Beneficios del tratamiento: </span>
                {beneficio?
                  <p name='beneficiosTratamiento'  className='border rounded p-2 text-xs'>{beneficio}</p>:
                  <textarea type="text" placeholder='Los beneficios razonables del tratamiento propuesto consisten en ' name='beneficiosTratamiento' value={input.beneficiosTratamiento} className='border rounded p-2 text-xs' onChange={handleChange} />
                }
            </div>

            <div className='flex flex-col'>
                <span className=' text-slate-300'>Las consecuencias de la denegación: </span>
                {consecuencia?
                 <p className='border rounded p-2 text-xs'>{consecuencia}</p>:
                 <textarea type="text" placeholder='Las consecuencias de la denegación por parte del paciente son' name='consecuenciasTratamiento' value={input.consecuenciasTratamiento} className='border rounded p-2 text-xs' onChange={handleChange} />
                }
            </div>

            <div className='flex flex-col'>
                <span className=' text-slate-300'>Los riesgos del tratamiento son: </span>
                {riesgo?
                <p className='border rounded p-2 text-xs'>{riesgo}</p>:
                <textarea type="text" placeholder='Los riesgos del tratamiento' name='riesgosTratamiento' value={input.riesgosTratamiento} className='border rounded p-2 text-xs' onChange={handleChange} />
                }
            </div>

            <div className='flex flex-col gap-2'>
              <span className='text-slate-400 '>Fecha del día:</span>
              <input type="date" placeholder='Fecha del día' value={input.fechaDelDia} name='fechaDelDia' className='border p-2 rounded' onChange={handleChangeDate} />
            </div>

            <button onClick={handleSubmit} className='p-2 rounded bg-background_home text-white text-xl'>ENVIAR</button>

        </form>
    </div>
  )
}

export default Anexo